import { useQuery } from '@tanstack/react-query';

/**
 * Parse course status from venue
 * Possible values: CONFIRMED, FULL, TBA
 * @param {string} venue
 * @returns {object}
 */
const parseCourseStatus = (string) => {
	if (string.includes('CONFIRMED ')) {
		return {
			venue: string.replace('CONFIRMED ', '').trim(),
			status: 'confirmed',
		};
	}

	if (string.includes('FULL ')) {
		return { venue: string.replace('FULL ', '').trim(), status: 'full' };
	}

	return { venue: string, status: '' };
};

/**
 * Fetch recipes with pagination and search
 * @returns {object}
 */
function useInstances({ id = null }) {
	const { isPending, isError, data, error } = useQuery({
		queryKey: ['instances'],
		queryFn: async () => {
			const response = await fetch(
				'https://us-central1-euneos-prod.cloudfunctions.net/api/courses/instances'
			);

			/**
			 * API returns all instances
			 * If id is null, return all instances
			 */
			if (id === null) {
				const instances = await response.json();
				return instances.sort((a, b) => a.start - b.start);
			}

			/**
			 * Else return instances filtered by model id
			 */
			const instances = await response.json();
			const filtered = instances.filter(
				(instance) => instance.model === id
			);

			return filtered.sort((a, b) => a.start - b.start);
		},
	});

	return {
		data,
		error,
		isError,
		isPending,
	};
}

export { useInstances };
